import clsx from "clsx";
import React, { useState } from "react";
import { BYPASS_BLOCK_ACTIVE_CLASS } from "../../ui/common/bypassBlocks";
import { getFocusableElements } from "../../ui/common/utils";

interface BypassBlockProps {
	label: string;
	skipTo: string;
}

export function BypassBlock({ label, skipTo }: BypassBlockProps) {
	const [isFocused, setIsFocused] = useState(false);

	const handleClick = (e) => {
		const focusableElements = getFocusableElements(
			document.getElementById(e.target.dataset.block),
		);

		if (focusableElements) {
			focusableElements[0].focus();
		}
	};

	const handleOnFocus = () => {
		setIsFocused(true);
	};

	const handleBlur = () => {
		setIsFocused(false);
	};

	return (
		<div
			className={clsx("bypass-block", {
				[BYPASS_BLOCK_ACTIVE_CLASS]: isFocused,
			})}
		>
			<button
				type="button"
				data-block={skipTo}
				onFocus={handleOnFocus}
				onBlur={handleBlur}
				onClick={handleClick}
			>
				{label}
			</button>
		</div>
	);
}
